// extracted by mini-css-extract-plugin
module.exports = {"root":"n80-trustpilot_root__yFDTE"};